var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_2149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6676 5.99935C14.1404 5.99935 15.3343 4.80544 15.3343 3.33268C15.3343 1.85992 14.1404 0.666016 12.6676 0.666016C11.1949 0.666016 10.001 1.85992 10.001 3.33268C10.001 4.80544 11.1949 5.99935 12.6676 5.99935Z",
    stroke: "#A35BB1",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.3324C9.47341 15.3324 10.6673 14.1384 10.6673 12.6657C10.6673 11.1929 9.47341 9.99902 8.00065 9.99902C6.52789 9.99902 5.33398 11.1929 5.33398 12.6657C5.33398 14.1384 6.52789 15.3324 8.00065 15.3324Z",
    stroke: "#A35BB1",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.934 5.33301H3.33398C2.20065 5.33301 1.33398 4.46634 1.33398 3.33301C1.33398 2.19967 2.20065 1.33301 3.33398 1.33301H10.934",
    stroke: "#A35BB1",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26731 14.666H3.33398C2.20065 14.666 1.33398 13.7993 1.33398 12.666C1.33398 11.5327 2.20065 10.666 3.33398 10.666H6.26731",
    stroke: "#A35BB1",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7334 10.666H12.6667C13.8001 10.666 14.6667 11.5327 14.6667 12.666C14.6667 13.1993 14.4667 13.7327 14.0667 14.066C13.7334 14.3993 13.2001 14.666 12.6667 14.666H9.7334",
    stroke: "#A35BB1",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_2149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterHorizontal);
export default __webpack_public_path__ + "static/media/filterHorizontal.837aed33c667cf3b8555f12ba0170016.svg";
export { ForwardRef as ReactComponent };